import React, {Component} from 'react';
import Gallery from 'react-photo-gallery';
import Lightbox from 'react-images';

class About extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      photosFetch: {
        photos: []
      },
      currentImage: 0 
    };
    this.closeLightbox = this.closeLightbox.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
  }
  
  componentDidMount() {
    fetch('/api/photos').then(res => res.json()).then(json => {
      this.setState({photosFetch: JSON.parse(json)});
    });
  }
  
  openLightbox(event, obj) {
  this.setState({
    currentImage: obj.index,
    lightboxIsOpen: true,
  });
}
closeLightbox() {
  this.setState({
    currentImage: 0,
    lightboxIsOpen: false,
  });
}
gotoPrevious() {
  this.setState({
    currentImage: this.state.currentImage - 1,
  });
}
gotoNext() {
  this.setState({
    currentImage: this.state.currentImage + 1,
  });
}


  render() {
    var PHOTO_SET_THUMB = [];
    var PHOTO_SET = [];
    
    for(let i = 0; i < this.state.photosFetch.photos.length; i++) {
      PHOTO_SET.push({
        src: "/img/photos/" + this.state.photosFetch.photos[i].url,
        width: this.state.photosFetch.photos[i].arW,
        height: this.state.photosFetch.photos[i].arH
      });
      PHOTO_SET_THUMB.push({
        src: "/img/photos/thumb/" + this.state.photosFetch.photos[i].url,
        width: this.state.photosFetch.photos[i].arW,
        height: this.state.photosFetch.photos[i].arH
      });
    }



    return (

      <section>
      <div className="Wrapper">
        <div className="Content">
          <h2>Photos</h2>
          <Gallery photos={PHOTO_SET_THUMB} onClick={this.openLightbox}  />
          <Lightbox images={PHOTO_SET}
          onClose={this.closeLightbox}
          onClickPrev={this.gotoPrevious}
          onClickNext={this.gotoNext}
          currentImage={this.state.currentImage}
          isOpen={this.state.lightboxIsOpen}
        />
      </div>
      
      </div>
      
    </section>);
  }
}

export default About;



// WEBPACK FOOTER //
// ./src/pages/Photos.js